define('datakit/base.model',['require','exports','module','underscore','backbone'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');

  var BaseModel = Backbone.Model.extend({

    _set: Backbone.Model.prototype.set,

    _get: Backbone.Model.prototype.get,

    onBeforeFirstSet: function() {},

    initializeMixin: function() {},

    set: function(key, value, options) {
      var attr, attrs, setter;
      // Normalize the key-value into an object
      if (_.isString(key)) {
        attrs = {};
        attrs[key] = value;
      } else {
        attrs = _.extend({}, key);
        options = value;
      }

      if (!this._hasSetBefore) {
        this._hasSetBefore = true;
        // this is being done here instead of inside an initialize function,
        // because Backbone set is being called before
        // initialize is being called, so to override the set function, it is necessary
        // to call intializeMixin here.
        this.initializeMixin(attrs, options);
        this.onBeforeFirstSet(attrs, options);
      }

      options = options || {};

      for (attr in attrs) {
        setter = this._findSetter(attr, _.extend({}, options, { value: attrs[attr] }));
        if (setter) {
          setter.call(this, attr, attrs[attr], options);
          delete attrs[attr];
        }
      }

      return this._set.call(this, attrs, options);
    },

    get: function(attr) {
      var getter;

      if (_.isString(attr)) {
        getter = this._findGetter(attr);
      }

      if (getter) {
        return getter.call(this, attr);
      }

      return this._get(attr);
    },

    clone: function(options) {
      var attrs       = _.clone(this.attributes),
          fullCloners = [];

      options = options || {};
      _.each(this._cloners, function(cloner) {
        var value;
        if (_.has(cloner, 'attr')) {
          value = cloner.clone.call(this, cloner.attr, attrs[cloner.attr], options);
          if (!_.isUndefined(value)) {
            attrs[cloner.attr] = value;
          }
        } else {
          fullCloners.push(cloner);
        }
      }, this);

      var model = new this.constructor(attrs);

      _.each(fullCloners, function(cloner) {
        cloner.clone.call(this, model, options);
      }, this);

      return model;
    },

    _toJSON: Backbone.Model.prototype.toJSON,

    toJSON: function(options) {
      var json = this._toJSON.apply(this, arguments);
      options = options || {};
      _.each(this._serializers, function(serializer) {
        var value;
        if (_.has(serializer, 'attr')) {
          value = serializer.serialize.call(this, serializer.attr, json[serializer.attr], options);
          if (!_.isUndefined(value)) {
            json[serializer.attr] = value;
          }
        } else {
          _.extend(json, serializer.serialize.call(this, json, options));
        }
      }, this);
      return json;
    },

    registerSetter: function(attrOrTester, setter) {
      if (!_.isFunction(setter)) { throw new Error('Setter must be a function') }

      if (!this._setters) {
        this._setters = {};
      }
      if (!this._dynamicSetters) {
        this._dynamicSetters = [];
      }
      if (_.isFunction(attrOrTester)) {
        // unshift to put at the beginning
        this._dynamicSetters.unshift({
          shouldSet: attrOrTester,
          set: setter
        });
      } else if (_.isRegExp(attrOrTester)) {
        // unshift to put at the beginning
        this._dynamicSetters.unshift({
          shouldSet: function(attr) { return attrOrTester.test(attr); },
          set: setter
        });
      } else {
        this._setters[attrOrTester] = setter;
      }
      return this;
    },

    registerGetter: function(attrOrTester, getter) {
      if (!_.isFunction(getter)) { throw new Error('Getter must be a function') }

      if (!this._getters) {
        this._getters = {};
      }
      if (!this._dynamicGetters) {
        this._dynamicGetters = [];
      }
      if (_.isFunction(attrOrTester)) {
        // unshift to put at the beginning
        this._dynamicGetters.unshift({
          shouldGet: attrOrTester,
          get: getter
        });
      } else if (_.isRegExp(attrOrTester)) {
        // unshift to put at the beginning
        this._dynamicGetters.unshift({
          shouldGet: function(attr) { return attrOrTester.test(attr); },
          get: getter
        });
      } else {
        this._getters[attrOrTester] = getter;
      }
      return this;
    },

    registerCloner: function(attr, fn) {
      if (!this._cloners) {
        this._cloners = [];
      }
      var cloner = {};
      if (_.isFunction(attr)) {
        cloner.clone = attr;
      } else if (_.isFunction(fn)){
        cloner.attr = attr;
        cloner.clone = fn;
      } else {
        throw new Error('A cloner requires a function');
      }
      this._cloners.push(cloner);
      return this;
    },

    registerSerializer: function(attr, fn) {
      if (!this._serializers) {
        this._serializers = [];
      }
      var serializer = {};
      if (_.isFunction(attr)) {
        serializer.serialize = attr;
      } else if (_.isFunction(fn)){
        serializer.attr = attr;
        serializer.serialize = fn;
      } else {
        throw new Error('A serializer requires a function');
      }
      this._serializers.push(serializer);
      return this;
    },

    _findSetter: function(attr, options) {
      var dynamicSetter = _.find(this._dynamicSetters, function(item) {
        return item.shouldSet.call(this, attr, options);
      }, this);

      if (dynamicSetter) {
        return dynamicSetter.set;
      } else if (this._setters && this._setters[attr]){
        return this._setters[attr];
      }
    },

    _findGetter: function(attr) {
      var dynamicGetter = _.find(this._dynamicGetters, function(item) {
        return item.shouldGet.call(this, attr);
      }, this);

      if (dynamicGetter) {
        return dynamicGetter.get;
      } else if (this._getters && this._getters[attr]) {
        return this._getters[attr];
      }
    }

  });
  module.exports = BaseModel;
});

